export default __webpack_public_path__ + "static/media/solar-site.d7e7ed7d.jpeg";